import { useQuery } from '@tanstack/react-query';

import type { StudyApi } from '@izimi/api';
import { THIRTY_MINUTES_MS } from '@izimi/utils';

import StudyQueryKeys from './StudyQueryKeys';

const studyQueryKeys = new StudyQueryKeys();

const createStudyModule = ({ studyApi }: { studyApi: StudyApi }) => {
  const useGetStudy = ({ studyId }: { studyId?: string }) => {
    const { data, isLoading, error, isSuccess } = useQuery({
      queryKey: studyQueryKeys.getStudy(studyId ?? ''),
      queryFn: () => studyApi.getStudy(studyId ?? ''),
      staleTime: THIRTY_MINUTES_MS,
      refetchOnWindowFocus: false,
      enabled: Boolean(studyId),
    });

    return {
      study: data,
      error,
      isLoading,
      isSuccess,
    };
  };

  return {
    useGetStudy,
  };
};

export default createStudyModule;
